import createStoreSlice from "../Utils/createStoreSlice";


const states = {

    userName: '',
    userRole: 'USER',
    defaultDashboard: 'USER',

    member: {
        progressInfo: {
            course: {
                total: 0,
                completed: 0,
                inProgress: 0,
                progress: 0,
                completionRate: 0
            },
            task: {
                total: 0,
                completed: 0,
                inProgress: 0,
                progress: 0,
                completionTime: 0
            },
            contest: {
                total: 0,
                completed: 0,
                inProgress: 0
            },
            time: {
                totalSpent: 0,
                consistencyScore: 0
            },
            activity: {
                mostActiveDay: null,
                streak: 0,
                activeSession: 0
            },
            totalProgress: 0,
        },

        upcomingEvents: [],

    },
    
    
    admin: {
        progressInfo: {
            course: {
                total: 0,
                completed: 0,
                inProgress: 0,
                progress: 0,
                avgCompletionTime: 0
            },
            task: {
                total: 0,
                completed: 0,
                inProgress: 0,
                progress: 0,
                avgCompletionTime: 0
            },
            contest: {
                total: 0,
                completed: 0,
                inProgress: 0
            },
            time: {
                totalSpent: 0,
                consistencyScore: 0
            },
            totalProgress: 0,
        },

        upcomingEvents: [],

        activityInfo: {
            contest: {
                totalParticipants: 0,
                totalSubmissions: 0,
                averageParticipationRate: 0,
                topContests: [],
                recentAttempts: []
            },

            course: {
                totalEnrollments: 0,
                activeEnrollments: 0,
                recentEnrollments: [],
                topCourses: [], 
            },

            task: {
                totalAssignments: 0,
                activeAssignments: 0,
                averageCompletionRate: 0,
                recentSubmissions: [],
                topTasks: [],
            }
        },

    },


    memberCalendarInfo: {
        selectedDate: null,
        startDate: null,
        endDate: null,
    },

    adminCalendarInfo: {
        selectedDate: null,
        startDate: null,
        endDate: null,
    }
}


const {reducer, useStore, useStoreHandlers} = createStoreSlice({name: "dashboardReducer", states})


export {
    reducer as dashboardReducer,
    useStore as useDashboardStore, 
    useStoreHandlers as useDashboardStoreHandlers
}